module.exports = __webpack_public_path__ + "media/components/Builder/Library/Modules/Page/Thumbnails/RoofingWidgets-2d764921e33788927e5c6bcea2a51ea5.png";